import {overlayHtml} from "../../overlayHtml";
import {BehaviorSubject, interval, Subject} from "rxjs";
import {ObjectConfig} from "../../../models/ObjectConfig";
import {MapPosition} from "../../../models/MapPosition";
import {debounceTime, throttle} from "rxjs/operators";
import {ItemConfig} from "../../../models/ItemConfig";
import {initOffset} from "ngx-bootstrap/chronos/units/offset";

export class MapTextOverlay extends overlayHtml{
  private view;
  public isCreated = false;
  private _isCreated$ = new Subject();
  get isCreated$(){
    return this._isCreated$.asObservable();
  }
  public id;
  public currentChangeListener;
  //item position
  private position;
  private anchor;
  private code;
  private currentInput;
  private mainVisibility = null;
  get globalVisibility(){
    return this.mainVisibility;
  }
  private lineOverlay = null;
  get hasLineOverlay(){
    return !!this.lineOverlay;
  }
  public isDisabledLabel = false;
  private _clickOnObject = new Subject();
  private _overlayDragStart = new Subject<boolean>();
  private _overlayDragged$ = new Subject<boolean>();
  get overlayDragged$(){
    return this._overlayDragged$.asObservable();
  }
  private mapTilesLoaded = new BehaviorSubject(false);
  private overlayDrawn$ = new Subject();
  get overlayDragStart(){
    return this._overlayDragStart.asObservable();
  }
  get clickOnObject(){
    return this._clickOnObject.asObservable();
  }
  constructor(view, id, position, input, name?) {
    super(id);
    this.id = id;
    this.position = position;
    this.view = view;
    this.currentInput = input;
    this.code = name || null;

    this.createOverlay(this.currentInput.__isObject && this.currentInput.__isObject.value);

    this.initListeners();
  }

  private initListeners(){
    this.view.overlayShowChanged.subscribe((overlay)=>{
      if (overlay == this.overlay){
        this.showTextOverlay();
      }
    });
    this.view.overlayUpdateChanged.subscribe((overlay)=>{
      if (overlay == this.overlay){
        this.showTextOverlay();
      }
    });
    this.view.isOverlayMouseDownFires.subscribe((overlay)=>{
      if (overlay == this.overlay){
        this._overlayDragStart.next(true);
      }
    });
    this.view.tilesLoaded.pipe(
      throttle(config => interval(500), {trailing: true})
    ).subscribe((val)=>{
      this.mapTilesLoaded.next(val);
    });


    this.view.$overlayDragged$.subscribe((overlay)=>{
      if (overlay == this.overlay){
        this._overlayDragged$.next(true);
      }
    })
  }


  public dragStart(){
    this.view.startDragLabelOverlay(this.overlay);
  }

  public setLabelDisabledValue(flag){
    this.isDisabledLabel = flag;
    this.overlay.isDisabledLabel = flag;
    (flag) ? this.hideTextOverlay() : this.showTextOverlay();
  }

  private getCrop(positions){
    var minLat = null;
    var minLng = null;
    var maxLat = null;
    var maxLng = null;
    for (var i = 0; i < positions.length; i++) {
      if (minLat === null || minLat > positions[i].lat) {
        minLat = positions[i].lat;
      }
      if (minLng === null || minLng > positions[i].lng) {
        minLng = positions[i].lng;
      }
      if (maxLat === null || maxLat < positions[i].lat) {
        maxLat = positions[i].lat;
      }
      if (maxLng === null || maxLng < positions[i].lng) {
        maxLng = positions[i].lng;
      }
    }
    var deltaLat = maxLat - minLat;
    var deltaLng = maxLng - minLng;
    var path = [];
    for (var i = 0; i < positions.length; i++) {
      path.push([
        (100 * (positions[i].lng - minLng) / deltaLng),
        (100 - 100 * (positions[i].lat - minLat) / deltaLat)
      ]);
    }
    return path;
  }

  public calculateTrackOverlaySize(itemConfig: ItemConfig ){

    let object = itemConfig.getObjectConfig();

    if (object.getPositions() && object.getPositions().length > 0) {

      var positions: MapPosition[] = object.getPositions();

        let rectangle = this.view.getRectangleFromPositions(positions);

       let path = this.getCrop(positions);

        let tilesPromise = new Promise((resolve, reject) => {
          let leftTop = null;
          let rightTop = null;
          let leftBottom = null;
          if (this.mapTilesLoaded.getValue()) {
            leftTop = this.view.getWindowCoordinatesFromMapPos(new MapPosition({
              lng: Cesium.Math.toDegrees(rectangle.west),
              lat: Cesium.Math.toDegrees(rectangle.north)
            }));
            rightTop = this.view.getWindowCoordinatesFromMapPos(new MapPosition({
              lng: Cesium.Math.toDegrees(rectangle.east),
              lat: Cesium.Math.toDegrees(rectangle.north)
            }));
            leftBottom = this.view.getWindowCoordinatesFromMapPos(new MapPosition({
              lng: Cesium.Math.toDegrees(rectangle.west),
              lat: Cesium.Math.toDegrees(rectangle.south)
            }));

            resolve({width: Math.abs(leftTop.x - rightTop.x), height: Math.abs(leftTop.y - leftBottom.y)});
          } else {
            let subscriber = this.mapTilesLoaded.subscribe((val) => {
              if (val) {
                leftTop = this.view.getWindowCoordinatesFromMapPos(new MapPosition({
                  lng: Cesium.Math.toDegrees(rectangle.west),
                  lat: Cesium.Math.toDegrees(rectangle.north)
                }));
                rightTop = this.view.getWindowCoordinatesFromMapPos(new MapPosition({
                  lng: Cesium.Math.toDegrees(rectangle.east),
                  lat: Cesium.Math.toDegrees(rectangle.north)
                }));
                leftBottom = this.view.getWindowCoordinatesFromMapPos(new MapPosition({
                  lng: Cesium.Math.toDegrees(rectangle.west),
                  lat: Cesium.Math.toDegrees(rectangle.south)
                }));
                resolve({width: Math.abs(leftTop.x - rightTop.x), height: Math.abs(leftTop.y - leftBottom.y)});
                subscriber.unsubscribe();
              }
            })
          }
        });
        tilesPromise.then((res: { width, height }) => {
          this.overlay.style.width = res.width + 'px';
          this.overlay.style.height = res.height + 'px';
          this.overlay.style.display = 'flex';
          this.overlay.style.justifyContent = 'center';
          this.overlay.style.alignItems = 'center';
        });

        let centerInRadians = Cesium.Rectangle.center(rectangle);
        this.applyCssFromInputs(itemConfig, Cesium.Cartographic.toCartesian(centerInRadians));

        this.overlay.style.clipPath = "polygon(" + path.map(function (i) {
          return '' + i[0] + '% ' + i[1] + '%';
        }).join(', ') + ")";
    //
    //   var proj = this.getProjection();
    //   var lt = proj.fromLatLngToDivPixel(new google.maps.LatLng(maxLat, minLng));
    //   var rb = proj.fromLatLngToDivPixel(new google.maps.LatLng(minLat, maxLng));
    //   div.style.width = Math.ceil(rb.x - lt.x) + 'px';
    //   div.style.height = Math.ceil(rb.y - lt.y) + 'px';
    // } else if (this._args.overlay.icon) {
    //   w = this._args.overlay.icon.scaledSize.width;
    //   h = this._args.overlay.icon.scaledSize.height;
    //   div.style.width = Math.ceil(w) + 'px';
    //   div.style.height = Math.ceil(h) + 'px';
    }
    else{
      let position = object.getPosition();
      this.applyCssFromInputs(itemConfig, this.view.getCartesianFromDegrees(position));
      let metersPerPx = this.view.getMetersPerPx(this.view.getCartesianFromDegrees(position));
      let width = object.getFixedWidth();
      let height = object.getFixedHeight();
      if (width && height){
        let widthInPx = width / metersPerPx;
        let heightInPx = height / metersPerPx;
        //add correction value
        this.overlay.style.width = widthInPx*1.5 + 'px';
        this.overlay.style.height = heightInPx*1.5 + 'px';
        this.overlay.style.display = 'flex';
        this.overlay.style.justifyContent = 'center';
        this.overlay.style.alignItems = 'center';
        this.overlay.style.overflow = 'hidden';
      }
    }
    // calculatedWidth = parseFloat(div.style.width);
    // calculatedHeight = parseFloat(div.style.height);
  }

  public applyCssFromInputs(itemConfig:ItemConfig, posInCartesian){
    let inputs = itemConfig.getInputs();
    var cssPrefix = this.code + '_css_';
    //google maps metersPerPxGoogle

    //metersPerPx
    let metersPerPx = this.view.getMetersPerPx(posInCartesian);

    for (var p in inputs) {
      if (inputs.hasOwnProperty(p)) {
        if (p.indexOf(cssPrefix) === 0) {
          var cssProp = p.substr(cssPrefix.length);
          if (itemConfig.getInputProp(p, 'value')) {
            var val = itemConfig.getInputProp(p, 'value');
            if (itemConfig.getInputProp(p, 'unit') === 'm') {
              val = Math.ceil(val / metersPerPx) + 'px';
            }

            else if (itemConfig.getInputProp(p, 'suffix') === 'px'){
              val += 'px';
            }

            this.overlay.style[cssProp] = val;
          }
        }
      }
    }
  }

  public setTextOverlay(value){
    if(value && value.toString().length>=0){
      this.view.changeTextOverlayContent(this.overlay, value.toString());
      this.showTextOverlay();
    }
    else{
      this.view.changeTextOverlayContent(this.overlay, '');
      this.hideTextOverlay();
    }
  }

  public setOverlayStyles(stylesStr){
    super.setOverlayStyles(stylesStr);
  }

  createTextOverlay(anchor, options){
    this.anchor = anchor;
    let _options = options || {};

    if (options.isPolygon){
      this.overlay.classList.add('es-polygon-map-text-overlay');
    }

    if (options.fixedPosition || options.isPolygon){
      anchor = "CENTER";
      this.anchor = anchor;
    }

    if (options.fixedPosition){
      if (typeof options.fixedPosition == 'string'){
        let fixedPosition = null;
        eval('fixedPosition = ' + options.fixedPosition);
        options.fixedPosition = fixedPosition;
      }
    }


    this.currentChangeListener = this.view.createTextOverlay(this.overlay, this.position, anchor, _options);
    let self = this;
    this.overlay.onclick = function (e) {
      self.view.htmlClicked = true;
      self._clickOnObject.next(e);
    };
    this.isCreated = true;
    this._isCreated$.next(true);
  }

  removeTextOverlay(){
    if (this.overlay){
      this.overlay.remove();
    }
  }

  public getLineLengthThreshold(){

    var units = 'px';
    if (this.currentInput.lineStyle.hasOwnProperty('lengthThreshold')) {
      if (this.currentInput.lineStyle.lengthThreshold.toString().substr(-1) == 'm') {
        units = 'm';
      }
      var threshold = parseInt(this.currentInput.lineStyle.lengthThreshold);
      if (units = 'm') {
        // var metersPerPx = this.view.getMetersPerPx();
        // threshold = threshold / metersPerPx;
        threshold = 4;
      }
      return threshold;
    }
  }

  createTextOverlayLine(input, anchor, labelOptions){
    this.lineOverlay = this.view.createLineInWindowCoordinates(this.overlay.id, this.position, anchor, this.getLineLengthThreshold(), input, labelOptions);
  }

  removeTextOverlayLine(){
    if (this.lineOverlay){
      this.lineOverlay.remove();
    }
  }

  overlayChangePosition(position, options, afterDraw?){
    let anchor = this.anchor;
    if (afterDraw || options.fixedPosition){
       anchor = "CENTER";
       this.anchor = "CENTER";
    }
    if (position){
      this.position = position;
    }
    this.view.changeTextOverlayPosition(this.currentChangeListener, this.overlay, position || this.position, anchor, options)
  }

  setMainVisibility(flag){
    this.mainVisibility = flag;
    this.overlay.mainVisibility = flag;
    if(flag){
      this.showTextOverlay();
    }else{
      this.hideTextOverlay()
    }
  }

  showTextOverlay(){
    if (!this.isDisabledLabel) {
      if (this.mainVisibility) {
        this.view.showTextOverlay(this.overlay);
        if (this.lineOverlay) {
          this.view.showTextOverlayLineLabel(this.lineOverlay, this.overlay);
        }
      }
    }
  }

  hideTextOverlay(){
    // if (this.mainVisibility === false){
      this.view.hideTextOverlay(this.overlay);
      if (this.lineOverlay){
        this.view.hideOverlayLabel(this.lineOverlay);
      }
    // }
  }
}
